// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  backdrop-filter: blur(2px);
}

.email-preview-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--color-bg-card, #2a2a2a);
  border: 2px solid var(--wylie-purple, #50076d);
  border-radius: 8px;
  padding: 30px;
  min-width: 600px;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
  z-index: 9999;
  animation: slideIn 0.25s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -45%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.email-preview-modal h2 {
  color: var(--wylie-purple);
  margin-top: 0;
  margin-bottom: 20px;
}

.email-preview-info {
  background-color: rgba(80, 7, 109, 0.1);
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.email-preview-info p {
  margin: 5px 0;
  color: var(--color-text-light);
  font-size: 14px;
}

.email-preview-info .email-preview-note {
  font-style: italic;
  color: var(--color-text-muted);
  font-size: 13px;
}

.email-preview-modal .form-group {
  margin-bottom: 20px;
}

.email-preview-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: var(--color-text-light);
}

.email-subject-input {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-border, #444);
  border-radius: 4px;
  font-size: 14px;
  background-color: var(--color-bg-input, #1e1e1e);
  color: var(--color-text-light);
}

.email-body-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-border, #444);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Courier New', monospace;
  background-color: var(--color-bg-input, #1e1e1e);
  color: var(--color-text-light);
  resize: vertical;
  min-height: 300px;
}

.email-subject-input:focus,
.email-body-textarea:focus {
  outline: none;
  border-color: var(--wylie-purple);
  box-shadow: 0 0 0 0.2rem rgba(80, 7, 109, 0.25);
}

.email-preview-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

/* Outlined like App.css's buttons: grey Cancel, purple Send. */
.email-preview-modal .btn-cancel,
.email-preview-modal .btn-send {
  padding: 10px 24px;
  background-color: transparent;
  border: 1px solid var(--btn-color);
  border-radius: 5px;
  color: var(--btn-color);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.email-preview-modal .btn-cancel {
  --btn-color: #adb5bd;
}

.email-preview-modal .btn-cancel:hover {
  background-color: var(--btn-color);
  color: #1f1f1f;
}

.email-preview-modal .btn-send {
  --btn-color: var(--part5-color);
}

.email-preview-modal .btn-send:hover:not(:disabled) {
  background-color: var(--btn-color);
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmailPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+CAA+C;EAC/C,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd","sourcesContent":[".email-preview-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  backdrop-filter: blur(2px);\n}\n\n.email-preview-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--color-bg-card, #2a2a2a);\n  border: 2px solid var(--wylie-purple, #50076d);\n  border-radius: 8px;\n  padding: 30px;\n  min-width: 600px;\n  max-width: 800px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  animation: slideIn 0.25s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -45%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.email-preview-modal h2 {\n  color: var(--wylie-purple);\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.email-preview-info {\n  background-color: rgba(80, 7, 109, 0.1);\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.email-preview-info p {\n  margin: 5px 0;\n  color: var(--color-text-light);\n  font-size: 14px;\n}\n\n.email-preview-info .email-preview-note {\n  font-style: italic;\n  color: var(--color-text-muted);\n  font-size: 13px;\n}\n\n.email-preview-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.email-preview-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: var(--color-text-light);\n}\n\n.email-subject-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--color-border, #444);\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: var(--color-bg-input, #1e1e1e);\n  color: var(--color-text-light);\n}\n\n.email-body-textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--color-border, #444);\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: 'Courier New', monospace;\n  background-color: var(--color-bg-input, #1e1e1e);\n  color: var(--color-text-light);\n  resize: vertical;\n  min-height: 300px;\n}\n\n.email-subject-input:focus,\n.email-body-textarea:focus {\n  outline: none;\n  border-color: var(--wylie-purple);\n  box-shadow: 0 0 0 0.2rem rgba(80, 7, 109, 0.25);\n}\n\n.email-preview-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n/* Outlined like App.css's buttons: grey Cancel, purple Send. */\n.email-preview-modal .btn-cancel,\n.email-preview-modal .btn-send {\n  padding: 10px 24px;\n  background-color: transparent;\n  border: 1px solid var(--btn-color);\n  border-radius: 5px;\n  color: var(--btn-color);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.email-preview-modal .btn-cancel {\n  --btn-color: #adb5bd;\n}\n\n.email-preview-modal .btn-cancel:hover {\n  background-color: var(--btn-color);\n  color: #1f1f1f;\n}\n\n.email-preview-modal .btn-send {\n  --btn-color: var(--part5-color);\n}\n\n.email-preview-modal .btn-send:hover:not(:disabled) {\n  background-color: var(--btn-color);\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
